import React from 'react'
import { MotionConfig, AnimationFeature, ExitFeature } from 'framer-motion'
import { AppContainer } from '../styles/globalStyles'
import NotFound from './NotFound'
import Logo from './Logo'
import Header from './Header'
import ServiceHeader from '../components/Navigation/ServiceHeader'
import Sections from './Sections'
import Background from './Background'

const App = () => {
  return (
    <MotionConfig features={[AnimationFeature, ExitFeature]}>
      {window.laborgg.data.not_found ? (
        <NotFound message={window.laborgg.data.not_found_message} />
      ) : (
        <AppContainer>
          <Background />
          <Logo />
          <Header />
          <ServiceHeader />
          <Sections />
        </AppContainer>
      )}
    </MotionConfig>
  )
}

export default App
